export class Queue<T> {
  private items: Map<string, QueueItem<T>> = new Map();
  private frontItemId: string = null;
  private rearItemId: string = null;

  public isEmpty(): boolean {
    return this.items.size === 0;
  }

  public getFront(): T {
    if (this.isEmpty()) {
      return;
    }

    const { item } = this.front();

    return item;
  }

  public push(item: T): void {
    this.enQueue(item);
  }

  public pop(): T {
    if (this.isEmpty()) {
      return;
    }

    return this.deQueue();
  }

  private enQueue(item: T): void {
    const queueItem = new QueueItem(item);
    const itemKey = this.makeUniqueKey();
    if (this.isEmpty()) {
      this.frontItemId = itemKey;
    } else {
      this.updateRearItemReference(itemKey);
    }
    this.rearItemId = itemKey;
    this.items.set(itemKey, queueItem);
  }

  private deQueue(): T {
    const frontItemId = this.frontItemId;
    const { next, item } = this.front();
    this.frontItemId = next;
    this.items.delete(frontItemId);
    if (this.isEmpty()) {
      this.frontItemId = null;
      this.rearItemId = null;
    }

    return item;
  }

  private makeUniqueKey(): string {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  }

  private front(): QueueItem<T> {
    return this.getQueueItemByKey(this.frontItemId);
  }

  private rear(): QueueItem<T> {
    return this.getQueueItemByKey(this.rearItemId);
  }

  private getQueueItemByKey(key: string): QueueItem<T> {
    return this.items.get(key);
  }

  private updateRearItemReference(next: string): void {
    const rearItem = this.rear();
    rearItem.next = next;
    this.items.set(this.rearItemId, rearItem);
  }
}

class QueueItem<T> {
  public next: string;
  public item: T;

  public constructor(item: T, next: string = null) {
    this.next = next;
    this.item = item;
  }
}
